import type { RightPanelSurface } from "~/rightPanelStore";
import {
  createDelegatedWorkspaceSurface,
  type DelegatedWorkspaceSurfaceContextValue,
} from "~/workspaceSurfaceContext";

type TerminalDescriptor = Extract<RightPanelSurface, { readonly kind: "terminal" }>;

export type TerminalWorkspaceSurfaceContextValue =
  DelegatedWorkspaceSurfaceContextValue<TerminalDescriptor>;

/**
 * Terminal-owned adapter for the Workspace Surface Host renderer seam.
 *
 * The Host mounts the UI attachment only while this descriptor is active.
 * The Environment-owned terminal process remains outside this adapter and is
 * terminated only by the explicit close action supplied by the feature.
 */
const terminalWorkspaceSurface = createDelegatedWorkspaceSurface<
  RightPanelSurface,
  TerminalDescriptor
>((descriptor): descriptor is TerminalDescriptor => descriptor.kind === "terminal");

export const TerminalWorkspaceSurfaceProvider = terminalWorkspaceSurface.Provider;
export const TerminalWorkspaceSurface = terminalWorkspaceSurface.Surface;
